export enum UserTypeEnum {
    PHYSICAL_PERSON = 1,
    LEGAL_ENTITY
}